import { Button } from "@/components/ui/button";
import { Flame, MoonStar, Sparkles } from "lucide-react";

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-[92vh] flex items-center"
    >
      <div className="max-w-6xl mx-auto w-full px-4 sm:px-6 lg:px-8 grid lg:grid-cols-12 gap-10 py-24 md:py-32">
        <div className="lg:col-span-7">
          <div
            data-testid="hero-eyebrow"
            className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-emerald-900/40 border border-emerald-700/40 text-emerald-200 text-xs uppercase tracking-[0.18em]"
          >
            <MoonStar className="w-3.5 h-3.5 text-amber-300" />
            99 Nights in the Forest · Roblox
          </div>

          <h1
            data-testid="hero-title"
            className="font-serif text-5xl sm:text-6xl lg:text-7xl leading-[1.05] mt-6 text-white"
          >
            Survive the night.<br />
            <span className="text-amber-400">Pick your perks</span><br />
            for $5 each.
          </h1>

          <p
            data-testid="hero-subtitle"
            className="mt-6 text-base md:text-lg text-emerald-100/80 leading-relaxed max-w-xl"
          >
            Grab any single perk for <span className="text-amber-400 font-bold">$5</span> —
            auto-fuel fire, infinite wood, metal, food, bandages or protection. Or unlock
            the full forest bundle (all 6) for just <span className="text-amber-400 font-bold">$20</span>.
            No grinding. Just vibes.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row gap-4">
            <Button
              data-testid="hero-cta"
              onClick={() => scrollTo("order")}
              className="ember-pulse h-14 px-8 rounded-2xl bg-[#FF7A00] hover:bg-[#FF9933] border border-amber-400/50 text-white text-base font-bold shadow-[0_0_30px_rgba(255,122,0,0.35)]"
            >
              <Flame className="w-5 h-5 mr-2" />
              Pick your perks — from $5
            </Button>
            <Button
              data-testid="hero-secondary"
              variant="ghost"
              onClick={() => scrollTo("how")}
              className="h-14 px-6 rounded-2xl text-emerald-100 hover:text-amber-400 hover:bg-emerald-900/30"
            >
              How it works →
            </Button>
          </div>

          <div className="mt-10 flex flex-wrap items-center gap-x-6 gap-y-3 text-sm text-emerald-100/60">
            <div className="flex items-center gap-2">
              <Sparkles className="w-4 h-4 text-amber-400" />
              <span>Delivered in-game by Roblox friend invite</span>
            </div>
            <div
              data-testid="hero-cashapp-badge"
              className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-amber-500/10 border border-amber-500/40 text-amber-300"
            >
              <span className="font-bold">Cash App only</span>
            </div>
          </div>
        </div>

        {/* Cozy campfire visual */}
        <div className="lg:col-span-5 relative">
          <div
            data-testid="hero-visual"
            className="relative aspect-[4/5] w-full rounded-3xl overflow-hidden border border-emerald-900/40 shadow-[0_20px_60px_rgba(0,0,0,0.6)]"
          >
            <div
              className="absolute inset-0"
              style={{
                backgroundImage:
                  "url('https://images.pexels.com/photos/9315792/pexels-photo-9315792.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=700')",
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#040B11] via-[#040B11]/30 to-transparent" />
            <div className="absolute bottom-6 left-6 right-6 backdrop-blur-xl bg-[#081622]/60 border border-emerald-900/40 rounded-2xl p-5">
              <p className="text-xs uppercase tracking-[0.18em] text-emerald-300 font-bold">
                Tonight's pricing
              </p>
              <p className="font-serif text-xl text-white mt-1">
                $5 per perk · $20 all-in
              </p>
              <div className="mt-3 flex items-baseline gap-2">
                <span className="font-serif text-4xl text-amber-400">$20</span>
                <span className="text-sm text-emerald-100/60">for all 6 perks</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
